'use-client';
import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import DropDownMenuBase from '../../DropDownMenuBase';
import ArrowRightMenuButtonNSkin from '../../../../MenuButton/viewer/skinComps/ArrowRightMenuButtonNSkin/ArrowRightMenuButtonNSkin';
import styles from './ArrowRightMenuButtonSkin.scss';

const ArrowRightMenuButtonSkin: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  IDropDownMenuProps
> = (props, ref) => {
  return (
    <DropDownMenuBase
      {...props}
      ref={ref}
      styles={styles}
      Button={ArrowRightMenuButtonNSkin}
    />
  );
};

export default React.forwardRef(ArrowRightMenuButtonSkin);
